import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const InputDSFR = (props) => {
  const { label = "", hint, id = "", name, type = "text", error = false, className = "", ...others } = props;
  let { errorMessage = [] } = props;

  if (!Array.isArray(errorMessage)) {
    errorMessage = [errorMessage];
  }

  const dsfrClassName = useMemo(() => (type === "file" ? "fr-upload" : "fr-input"), [type]);

  return (
    <div
      className={`${dsfrClassName}-group${error ? ` ${dsfrClassName}-group--error` : ""}${
        className ? ` ${className}` : ""
      }`}
      id="input-group"
    >
      <label className="fr-label" htmlFor={`input-${id || name}`}>
        {label}
        <span className="fr-hint-text">{hint}</span>
      </label>
      <Box
        component={name === "message" ? "textarea" : "input"}
        name={name}
        className={dsfrClassName}
        aria-describedby={`input-${id || name}-message`}
        id={`input-${id || name}`}
        type={type}
        spellCheck="false"
        {...others}
      />
      {error &&
        errorMessage &&
        errorMessage.map((message, index) => (
          <div
            key={message}
            className="fr-messages-group"
            id={`input-${id || name}-message-${index}`}
            aria-live="polite"
          >
            <p className="fr-message fr-message--error" id={`input-${id || name}-error-${index}`}>
              {message}
            </p>
          </div>
        ))}
    </div>
  );
};

InputDSFR.propTypes = {
  label: PropTypes.string,
  hint: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  className: PropTypes.string,
};

export default InputDSFR;
